
export enum OrderViewType {
    Tile = 0,
    Table
}


// WEBPACK FOOTER //
// ./app/objects/management/order/orderViewType.ts